@let cfg = config();

<nav [class]="navClass()">
  <div class="flex gap-4 items-center">
    @if (cfg.showMenuButton) {
      <button
        nbxButton
        type="button"
        variant="utility"
        icon="pi pi-bars"
        [attr.aria-label]="'A11Y.MENU' | transloco"
        (click)="menuClick.emit()"
      ></button>
    }
    @if (cfg.logo) {
      <img
        [src]="cfg.logo"
        [alt]="cfg.title ?? 'Logo'"
        class="h-auto navbar-logo cursor-pointer"
        role="button"
        tabindex="0"
        (click)="onLogoClick()"
      />
    }
    @if (cfg.title) {
      <span class="text-sm font-bold text-secondary leading-normal">
        {{ cfg.title }}
      </span>
    }
    @if (cfg.breadcrumbs?.length) {
      <nbx-breadcrumb [items]="cfg.breadcrumbs ?? []" />
    }
  </div>

  @if (cfg.actions?.length) {
    <div class="flex items-center gap-4 navbar-actions">
      @for (action of cfg.actions; track $index) {
        @if (action.type === 'menu' && action.menuItems?.length) {
          <nbx-menu-button
            [icon]="action.icon"
            [tooltip]="action.tooltip ?? ''"
            [badge]="action.badge"
            [menuItems]="action.menuItems!"
            [ngModel]="action.selectedMenuItemValue"
            (ngModelChange)="action.onSelect?.($event)"
          />
        } @else {
          <!-- Button Action -->
          <button
            nbxButton
            type="button"
            variant="utility"
            [icon]="action.icon"
            [badge]="action.badge ?? null"
            [attr.aria-label]="action.tooltip | transloco"
            (click)="action.onClick?.()"
          ></button>
        }
      }
    </div>
  }
</nav>
